module.exports = __webpack_public_path__ + "img/p2.41192a75.jpg";